
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  position: relative;
  display: block;
  height: 100%;
  place-self: stretch;
  overflow: hidden;
  border-radius: 0.75rem;
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  :host section {
  display: flex;
}

  :host section {
  flex-direction: column;
}

  :host section {
  overflow: hidden;
}

  :host section {
  text-align: left;
}

.search-results-card {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  place-self: stretch;
  background-color: var(--neutral-white);
  padding: 1.5rem;
}

.image-tags {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.image-tags-no-image {
  position: relative;
}

.image-tags-image {
  position: absolute;
  top: 1.25rem;
  z-index: 60;
  padding: 1rem;
}

.image {
  position: relative;
  margin-bottom: 1rem;
  display: flex;
  height: 225px;
  min-height: 225px;
  width: 100%;
  overflow: hidden;
  border-radius: 0.5rem;
}

::slotted([slot='image']) {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.heading-label {
  white-space: nowrap;
}

.image-profile-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--blue-responsible-lighten-3);
  width:100% !important;
}

.image-profile-placeholder svg {
  width: 30% !important;
}

.image-profile-placeholder svg{
    stroke:var(--blue-responsible-darken-2);
  }

.image-video-thumbnail idb-icon {
  position: absolute;
  z-index: 40;
  width: 100%;
  font-size: var(--fs-5xl);
  line-height: var(--lh-5xl);
  color: var(--neutral-white);
  bottom:35%;
  left:40%;
  filter:drop-shadow(0 0 0.75rem var(--blue-responsible-lighten-3));
}

.image-video-thumbnail span.overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  z-index: 30;
  height: 100%;
  width: 100%;
  background-color: var(--gray-professional-darken-2);
  opacity: 0.4;
}

.card-caption {
  margin-bottom: 0.5rem;
  color: var(--gray-professional-darken-1);
}

.card-eyebrow {
  margin-bottom: 0px;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  color: var(--blue-responsible-darken-1);
}

.card-title {
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  width: 100%;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  font-weight: var(--fw-semibold);
  color: var(--blue-responsible-darken-1);
}

.card-summary {
  margin-bottom: 0px;
  overflow-wrap: break-word;
  color: var(--gray-professional-lighten-1);
}

.card-cta {
  margin-top: 1rem;
  flex-grow:1;
  display:flex;
  align-items:flex-end;
}
`;